import { render, staticRenderFns } from "./weblink.vue?vue&type=template&id=7a360e52&scoped=true&"
import script from "./weblink.vue?vue&type=script&lang=js&"
export * from "./weblink.vue?vue&type=script&lang=js&"
import style0 from "./weblink.vue?vue&type=style&index=0&id=7a360e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a360e52",
  null
  
)

export default component.exports